/*
*
* File JS componente Block Gallery
*
*/


// IMPORT SCSS PER LA COMPILAZIONE
import './block-gallery.scss';
//--------------------------------------------------------------------//

//import Swiper 
import Swiper, { A11y, Navigation, Lazy, Thumbs } from "swiper";
import 'swiper/css/bundle';

//Import Light Gallery
require ('lightgallery.js');
import 'lightgallery.js/dist/css/lightgallery.min.css';

//--------------------------------------------------------------------//



// EXPORT COMPONENTE
//--------------------------------------------------------------------//


const gallery = () => {

    window.addEventListener('load' , () => {
        const schedaGallery = document.querySelector("#scheda-gallery");
        if(!schedaGallery) return;
    
        const galleryTop = new Swiper("#gallery-top", {
            modules: [Navigation, A11y],
            spaceBetween: 20,
            autoHeight:true,
            calculateHeight:true,
            preloadImages: true,
            observer: true,
            observeParents: true,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
            // breakpoints: {
            //     '1024':{
            //         autoHeight:false, 
            //     },
            //     '0':{
            //         autoHeight:true,
            //     }
            // },
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 10,
            },
            A11y: {
            enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        });
    
        const galleryThumbs = new Swiper("#gallery-thumbs", {
            modules: [Navigation, A11y, Thumbs, Lazy],
            centeredSlides: true,
            slidesPerView: "auto",
            slideToClickedSlide: true,
            watchSlidesVisibility: true,
            lazy: {
                loadPrevNext: true,
                loadPrevNextAmount: 30,
            },
            thumbs: {
                swiper: galleryTop,
            },
            A11y: {
                enabled: true,
                prevSlideMessage: "Previous slide",
                nextSlideMessage: "Next slide",
                firstSlideMessage: "This is the first slide",
                lastSlideMessage: "This is the last slide",
                paginationBulletMessage: "Go to slide {{index}}",
                notificationClass: "swiper-notification",
            },
        });
    
        galleryTop.on("slideChange", function () {
            galleryThumbs.slideTo(galleryTop.activeIndex);
        });
    });

    const allLightGallery = document.querySelectorAll('[data-thumbnails-gallery]');
    if( !allLightGallery.length ) return;

    allLightGallery.forEach(gallery =>
    {
        lightGallery(gallery,
        {
            thumbnail: true,
            download: false,
            mobileSettings:
            {
                controls: false,
                showCloseIcon: true,
                download: false
            }
        });
    });

 }

export default gallery;

//--------------------------------------------------------------------//

